import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	browseTemplates: {
		id: 'jira.navigation.apps.sidebar-nav4.sidebars.content.projects.browse-templates.ui.browse-templates',
		defaultMessage: 'Browse templates',
		description: 'Label for the browse templates menu item in project sidebar',
	},
});
